import { RequestService } from 'services/request.service'
import { ContestRequest, ContestResponse, ContestSubmissionType } from './apiTypes/contest.types'

export class ContestService extends RequestService {
    create = async (submission: ContestRequest): Promise<ContestResponse> => {
        return super.post(`/api/comments/contestSubmission/`, {
            owner: submission.ownerId,
            parentPost: submission.parentPostId,
            deck: submission.deckId,
        })
    }

    remove = async (contestSubmissionId: string | number): Promise<void> => {
        return super.delete(`/api/comments/contestSubmission/delete/${contestSubmissionId}/`, undefined, true)
    }

    list = async (parentPostId: number | string, pageNumber: string | number = 1, orderBy: string = '-updatedAt'): Promise<ContestResponse> => {
        return super.get(`/api/comments/contestSubmission/decks/${parentPostId}/?page=${pageNumber}&orderBy=${orderBy}`)
    }

    review = async (submission: ContestSubmissionType, reviewedFlag: boolean): Promise<void> => {
        return super.patch(`/api/comments/contestSubmission/reviewer/${submission.id}/`, {
            ...submission, reviewed: reviewedFlag,
        })
    }

}

const contestService = new ContestService()

export default contestService